import React, { useState, useRef, useEffect } from 'react';

const sizeClasses = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  full: 'max-w-full'
};

const Modal = ({ show, onClose, title, children, size = 'md', footer }) => {
  const modalRef = useRef(null);

  // Inicializamos la posición centrada
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [rel, setRel] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (show && modalRef.current) {
      const rect = modalRef.current.getBoundingClientRect();
      setPosition({
        x: window.innerWidth / 2 - rect.width / 2,
        y: window.innerHeight / 2 - rect.height / 2,
      });
    }
  }, [show]);

  if (!show) return null;

  const onMouseDown = (e) => {
    if (e.button !== 0) return;
    const rect = modalRef.current.getBoundingClientRect();
    setRel({
      x: e.pageX - rect.left,
      y: e.pageY - rect.top,
    });
    setDragging(true);
    e.preventDefault();
  };

  const onMouseUp = () => setDragging(false);

  const onMouseMove = (e) => {
    if (!dragging) return;
    setPosition({
      x: e.pageX - rel.x,
      y: e.pageY - rel.y,
    });
    e.preventDefault();
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ backgroundColor: 'rgba(40, 44, 52, 0.8)' }}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseUp}
      //onClick={onClose}  // clic afuera cierra modal
    >
      <div
        ref={modalRef}
        className={`
          bg-white rounded-lg shadow-2xl w-full p-0 overflow-hidden
          ${sizeClasses[size] || sizeClasses.md}
          transform transition-all duration-300 ease-in-out
          cursor-default
        `}
        style={{
          position: 'absolute',
          left: position.x,
          top: position.y,
        }}
        onClick={e => e.stopPropagation()} // evita cerrar modal al click interno
      >
        <div
          className="bg-gradient-to-r from-blue-500 to-indigo-500 p-4 flex justify-between items-center cursor-move select-none"
          onMouseDown={onMouseDown}
        >
          <h2 className="text-white text-sm font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-300 text-2xl font-bold leading-none"
            aria-label="Cerrar modal"
          >
            &times;
          </button>
        </div>

        <div className="p-6 max-h-[80vh] overflow-y-auto text-gray-800">
          {children}
        </div>

        {footer && (
          <div className="bg-gray-100 px-6 py-4 flex justify-end gap-3 rounded-b-lg">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
